import { App, Modal, Form, Input, notification, Button, Select, Spin, Segmented } from 'antd';
import React, { useEffect, useState } from 'react';
import { _T } from '../../../../../base-react/src/Localization';
import { apis, hooks, models } from "@vote4dance/judging-sdk";
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var DivisionSource = models.federations.DivisionSource;
var DisciplineSource = models.federations.DisciplineSource;
var FederationClassSource = models.federations.FederationClassSource;
var ClassItem = models.classes.ClassItem;
var ClassesSource = models.classes.ClassesSource;
import { useCompetition } from '../../../../../base-react/hooks/Competition';
import { ClassRole } from '@vote4dance/judging-schema';
import { ReloadOutlined } from '@ant-design/icons';
export const ClassItemEdit = (props) => {
    var _a;
    const { competition_id, classItem, visible, setVisible } = props;
    const { modal } = App.useApp();
    const [isLoading, setIsLoading] = useState(false);
    const [mergeMode, setMergeMode] = useState(false);
    const [groupMode, setGroupMode] = useState(classItem ? parseInt(classItem.class_group_id) > 0 : false);
    const [form] = Form.useForm();
    const [inputCompetition, event, competitions, loadingCompetition] = useCompetition(competition_id);
    const classMode = Form.useWatch('class_mode', form);
    const division_id = Form.useWatch('division_id', form);
    const discipline_id = Form.useWatch('discipline_id', form);
    const federation_class_id = Form.useWatch('federation_class_id', form);
    const classesSource = ClassesSource(competition_id);
    const [filteredClasses, setFilteredClasses] = useState([]);
    const [classes, loadingClasses] = Stream((mergeMode || groupMode) ? classesSource : undefined);
    const [divisions, loadingDivisions] = Stream(inputCompetition && DivisionSource(inputCompetition.federation_id));
    const [disciplines, loadingDisciplines] = Stream(inputCompetition && DisciplineSource(inputCompetition.federation_id, division_id));
    const [federationClasses, loadingFederationClasses] = Stream(inputCompetition && FederationClassSource(inputCompetition.federation_id));
    useEffect(() => {
        if (!visible) {
            return;
        }
        setMergeMode(false);
        setGroupMode(classItem ? parseInt(classItem.class_group_id) > 0 : false);
        form.resetFields();
        form.setFieldsValue(getDefaultValue());
    }, [visible, classItem]);
    useEffect(() => {
        if (!visible) {
            return;
        }
        if (federationClasses) {
            setFilteredClasses(federationClasses.filter(a => a.discipline_id === discipline_id)
                .sort((a, b) => ((a.federation_class_order != null ? a.federation_class_order : Number(a.federation_class_id))
                -
                    (b.federation_class_order != null ? b.federation_class_order : Number(b.federation_class_id)))));
        }
    }, [visible, federationClasses, discipline_id]);
    const getDefaultValue = () => ({
        ...classItem,
        class_group_id: (classItem && parseInt(classItem.class_group_id) > 0) ? classItem.class_group_id : null,
        class_mode: 'single'
    });
    const onFinish = async (fieldsValue) => {
        setIsLoading(true);
        if (classMode === 'merge') {
            const leaderFederationClass = filteredClasses === null || filteredClasses === void 0 ? void 0 : filteredClasses.find(a => a.federation_class_id == fieldsValue['federation_class_id_leader']);
            const followerFederationClass = filteredClasses === null || filteredClasses === void 0 ? void 0 : filteredClasses.find(a => a.federation_class_id == fieldsValue['federation_class_id_follower']);
            const groupFederationClass = filteredClasses === null || filteredClasses === void 0 ? void 0 : filteredClasses.find(a => a.federation_class_id == fieldsValue['federation_class_id']);
            const groupClass = {
                division_id: fieldsValue['division_id'],
                discipline_id: fieldsValue['discipline_id'],
                federation_class_id: fieldsValue['federation_class_id_group'],
                class_label: groupFederationClass ? groupFederationClass.federation_class_name : '',
                class_name: groupFederationClass ? groupFederationClass.federation_class_code : '',
            };
            const parentClass = await Api.create(classesSource.url, groupClass)
                .catch((err) => {
                setIsLoading(false);
                notification.error({
                    message: err.response && err.response.message ? _T(err.response.message) : err.message
                });
            });
            if (parentClass) {
                const leaderClass = {
                    division_id: fieldsValue['division_id'],
                    discipline_id: fieldsValue['discipline_id'],
                    federation_class_id: fieldsValue['federation_class_id_leader'],
                    class_label: leaderFederationClass ? leaderFederationClass.federation_class_name : '',
                    class_name: leaderFederationClass ? leaderFederationClass.federation_class_code : '',
                    class_role: 'leader',
                    class_group_id: parentClass.class_id
                };
                const followerClass = {
                    division_id: fieldsValue['division_id'],
                    discipline_id: fieldsValue['discipline_id'],
                    federation_class_id: fieldsValue['federation_class_id_follower'],
                    class_label: followerFederationClass ? followerFederationClass.federation_class_name : '',
                    class_name: followerFederationClass ? followerFederationClass.federation_class_code : '',
                    class_role: 'follower',
                    class_group_id: parentClass.class_id
                };
                await Api.create(classesSource.url, leaderClass)
                    .catch((err) => {
                    notification.error({
                        message: err.response && err.response.message ? _T(err.response.message) : err.message
                    });
                });
                await Api.create(classesSource.url, followerClass)
                    .catch((err) => {
                    notification.error({
                        message: err.response && err.response.message ? _T(err.response.message) : err.message
                    });
                });
            }
            form.resetFields();
            setIsLoading(false);
            setVisible(false);
        }
        else {
            const updateItem = {
                ...classItem,
                ...fieldsValue,
                class_group_id: fieldsValue['class_group_id'] || 0
            };
            if (classItem && mergeMode) {
                Api.call(`${classesSource.url}/${classItem.class_id}`, 'merge', {
                    target: fieldsValue['merge_class_id']
                })
                    .then(() => {
                    form.resetFields();
                    setIsLoading(false);
                    setVisible(false);
                })
                    .catch((err) => {
                    setIsLoading(false);
                    notification.error({
                        message: err.response && err.response.message ? _T(err.response.message) : err.message
                    });
                });
                return;
            }
            if (classItem) {
                Api.update(`${classesSource.url}/${classItem.class_id}`, updateItem)
                    .then(() => {
                    form.resetFields();
                    setIsLoading(false);
                    setVisible(false);
                })
                    .catch((err) => {
                    setIsLoading(false);
                    notification.error({
                        message: err.response && err.response.message ? _T(err.response.message) : err.message
                    });
                });
            }
            else {
                Api.create(classesSource.url, updateItem)
                    .then(() => {
                    form.resetFields();
                    setIsLoading(false);
                    setVisible(false);
                })
                    .catch((err) => {
                    setIsLoading(false);
                    notification.error({
                        message: err.response && err.response.message ? _T(err.response.message) : err.message
                    });
                });
            }
        }
    };
    const handleCancel = () => {
        form.resetFields();
        setVisible(false);
    };
    const handleDelete = () => {
        if (!classItem) {
            return;
        }
        modal.confirm({
            title: _T('common.delete.title', { name: _T('class.title').toLowerCase() }),
            content: _T('common.delete.content', { name: ClassItem.getClassLabel(classItem) }),
            onOk() {
                Api.destroy(`${classesSource.url}/${classItem.class_id}`)
                    .then(() => {
                    handleCancel();
                })
                    .catch((err) => {
                    notification.error({
                        message: err.response && err.response.message ? _T(err.response.message) : err.message
                    });
                });
            }
        });
    };
    const handleSeparate = () => {
        if (!classItem) {
            return;
        }
        setIsLoading(true);
        Api.call(`${classesSource.url}/${classItem.class_id}`, 'separate', {})
            .then(() => {
            form.resetFields();
            setIsLoading(false);
            setVisible(false);
        })
            .catch((err) => {
            setIsLoading(false);
            notification.error({
                message: err.response && err.response.message ? _T(err.response.message) : err.message
            });
        });
    };
    const updateNameFromSettings = (fieldName, federationFieldName) => {
        const foundClass = federationClasses === null || federationClasses === void 0 ? void 0 : federationClasses.find(a => a.federation_class_id == federation_class_id);
        if (foundClass) {
            form.setFieldValue(fieldName, foundClass[federationFieldName]);
        }
    };
    return (React.createElement(Modal, { title: _T(classItem ? 'common.edit' : 'common.add', { name: _T('class.title').toLowerCase() }), open: visible, width: 700, onCancel: handleCancel, footer: [
            classItem &&
                React.createElement(Button, { key: "delete", type: "dashed", onClick: handleDelete, danger: true }, _T('common.delete.title')),
            classMode === 'single' &&
                React.createElement(Button, { key: "group", type: "dashed", onClick: () => setGroupMode(true), disabled: groupMode }, _T('class.group.title')),
            classItem &&
                React.createElement(Button, { key: "merge", type: "dashed", onClick: () => setMergeMode(true), disabled: mergeMode }, _T('class.merge.title')),
            classItem && ((_a = classItem.class_name) === null || _a === void 0 ? void 0 : _a.includes('/')) &&
                React.createElement(Button, { key: "separate", type: "dashed", onClick: handleSeparate, disabled: mergeMode }, _T('class.merge.separate')),
            React.createElement(Button, { key: "cancel", onClick: handleCancel }, _T('common.cancel.title')),
            React.createElement(Button, { key: "submit", type: "primary", form: `class_item_settings_${classItem === null || classItem === void 0 ? void 0 : classItem.class_id}`, htmlType: 'submit', disabled: isLoading, loading: isLoading }, _T('common.save'))
        ] },
        React.createElement(Form, { name: `class_item_settings_${classItem === null || classItem === void 0 ? void 0 : classItem.class_id}`, form: form, layout: "vertical", onFinish: onFinish, initialValues: getDefaultValue() },
            React.createElement(Form.Item, { name: "division_id" },
                React.createElement(Select, { loading: loadingDivisions, placeholder: _T('class.details.division_id'), disabled: isLoading || mergeMode, allowClear: true }, divisions && divisions.map(item => (React.createElement(Select.Option, { value: item.division_id, key: item.division_id }, item.division_name))))),
            React.createElement(Form.Item, { name: "discipline_id" },
                React.createElement(Select, { loading: loadingDisciplines, placeholder: _T('class.details.discipline_id'), disabled: isLoading || mergeMode, allowClear: true }, disciplines && disciplines.map(item => (React.createElement(Select.Option, { value: item.discipline_id, key: item.discipline_id }, item.discipline_name))))),
            React.createElement(Form.Item, { name: "class_mode", hidden: classItem != null },
                React.createElement(Segmented, { options: [
                        {
                            label: _T('class.mode.single'),
                            value: 'single',
                        },
                        {
                            label: _T('class.mode.merge'),
                            value: 'merge',
                        },
                    ], disabled: isLoading })),
            React.createElement(Form.Item, { name: "federation_class_id_leader", hidden: classMode !== 'merge', rules: [{ required: classMode === 'merge', message: _T('common.required') }] },
                React.createElement(Select, { loading: loadingFederationClasses, placeholder: _T('danceteam.details.dance_role.leader'), disabled: isLoading || mergeMode, allowClear: true }, filteredClasses && filteredClasses.map(item => (React.createElement(Select.Option, { value: item.federation_class_id, key: item.federation_class_id }, item.federation_class_name))))),
            React.createElement(Form.Item, { name: "federation_class_id_follower", hidden: classMode !== 'merge', rules: [{ required: classMode === 'merge', message: _T('common.required') }] },
                React.createElement(Select, { loading: loadingFederationClasses, placeholder: _T('danceteam.details.dance_role.follower'), disabled: isLoading || mergeMode, allowClear: true }, filteredClasses && filteredClasses.map(item => (React.createElement(Select.Option, { value: item.federation_class_id, key: item.federation_class_id }, item.federation_class_name))))),
            React.createElement(Form.Item, { name: "federation_class_id" },
                React.createElement(Select, { loading: loadingFederationClasses, placeholder: _T(classMode === 'merge' ? 'round.final' : 'class.details.federation_class_id'), disabled: isLoading || mergeMode, allowClear: true }, filteredClasses && filteredClasses.map(item => (React.createElement(Select.Option, { value: item.federation_class_id, key: item.federation_class_id }, item.federation_class_name))))),
            React.createElement(Form.Item, { name: "class_label", hidden: classMode !== 'single', rules: [{ required: classMode === 'single', message: _T('common.required') }] },
                React.createElement(Input, { autoFocus: true, disabled: isLoading || mergeMode, allowClear: true, placeholder: _T('common.add', { name: _T('class.details.class_label').toLowerCase() }), addonAfter: loadingFederationClasses ? React.createElement(Spin, null) : React.createElement(ReloadOutlined, { onClick: () => updateNameFromSettings('class_label', 'federation_class_name') }) })),
            React.createElement(Form.Item, { name: "class_name", hidden: classMode !== 'single', rules: [{ required: classMode === 'single', message: _T('common.required') }] },
                React.createElement(Input, { disabled: isLoading || mergeMode, allowClear: true, placeholder: _T('common.add', { name: _T('class.details.class_name').toLowerCase() }), addonAfter: loadingFederationClasses ? React.createElement(Spin, null) : React.createElement(ReloadOutlined, { onClick: () => updateNameFromSettings('class_name', 'federation_class_code') }) })),
            React.createElement(Form.Item, { name: "merge_class_id", hidden: !mergeMode },
                React.createElement(Select, { loading: loadingClasses, placeholder: _T('class.merge.target'), allowClear: true }, classes && classes.map(item => (React.createElement(Select.Option, { value: item.class_id, key: item.class_id, disabled: (classItem === null || classItem === void 0 ? void 0 : classItem.class_id) === item.class_id }, ClassItem.getClassLabel(item)))))),
            React.createElement(Form.Item, { name: "class_group_id", hidden: !groupMode },
                React.createElement(Select, { loading: loadingClasses, placeholder: _T('class.group.target'), allowClear: true }, classes && classes.map(item => (React.createElement(Select.Option, { value: item.class_id, key: item.class_id, disabled: (classItem === null || classItem === void 0 ? void 0 : classItem.class_id) === item.class_id }, ClassItem.getClassLabel(item)))))),
            React.createElement(Form.Item, { name: "class_role", hidden: !groupMode },
                React.createElement(Select, { placeholder: _T('class.details.class_role.label'), allowClear: true, options: Object.keys(ClassRole).map((status, index) => ({ value: ClassRole[status], label: _T('class.details.class_role.' + status.toLowerCase()) })) })))));
};
